import { render, staticRenderFns } from "./LastTransactions.vue?vue&type=template&id=f0726b16&"
import script from "./LastTransactions.vue?vue&type=script&lang=js&"
export * from "./LastTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports